import {BaseDTO} from '../../../common/models/BaseDTO';
import {NameValueCodeDTO} from '../../../common/models/NameValueCodeDTO';

export class DocumentReviewDTO extends BaseDTO {
  documentId: number;
  transactionId: number;
  fileName: string;
  fileId: number;
  fileUrl: string;
  isActive: number;
  documentType: NameValueCodeDTO;
  documentReferenceType: NameValueCodeDTO;
}
